///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-employee-categories.collection.ts"/>
///<reference path="../collections/report-employees.collection.ts"/>
///<reference path="../collection-population-strategies/employee-to-categories.strategy.ts"/>
///<reference path="report-employee-secure.ts"/>
///<reference path="../validation/reqired-if-all-unselected.validation.ts"/>


module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export class ReportEmployeeStudentTeacherDataTemplate extends ReportSecureEmployeeDataTemplate implements ISecureDataTemplate {
        private readonly employeeCategories: ReportEmployeeCategoriesCollection;
        public required: boolean;
        private labelKeys: IMoverLabelKeys;
        public allSelected: boolean;

        get collection(): ICollectionBase<any> {
            return this.employeeCategories;
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        /**
         *
         * @param model
         * @param properties - [categoryIds, employeeIds]
         * @param options
         */
        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, [properties[1]], options);
            if (typeof this.model[properties[0]] === 'undefined') {
                this.model[properties[0]] = [];
            }

            this.labelKeys = options.labelKeys;
            this.title = this.labelKeys.title || 'LABEL_ALL_EMPLOYEES_UPPER';
            this.allSelectedLabel = this.labelKeys.allSelectedLabel || 'LABEL_ALL_EMPLOYEES_UPPER'; 
            this.totalSelectedMessage = this.labelKeys.totalSelectedMessage || 'LABEL_TOTAL_EMPLOYEES_SELECTED';

            this.voidIfAllSelected = true;
            this.employeeCategories = new ReportEmployeeCategoriesCollection(this.model[properties[0]], [], { criteria: options.criteria });
            this.employees.setParentCollection(this.employeeCategories, EmployeeToCategoriesStrategy);
            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: this.labelKeys.filterLabel || 'LABEL_HIDE_INACTIVE_EMPLOYEES' })
            ];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);

            if (options.required) {
                this.required = true;
                this.addValidation();
            }
        }

        setWatchers(scope: angular.IScope) {
            this.employeeCategories.setWatchers(scope);
            super.setWatchers(scope);
            this.setValidationWatcher(scope);
        }

        setValidationWatcher(scope: angular.IScope) {
            scope.$watch(() => this.required, (newValue, oldValue) => {
                if (newValue == oldValue) return;

                if (newValue == true) {
                    this.addValidation();
                } else {
                    this.removeValidation();
                }
            });
        }

        addValidation() {
            if (this.validation.length > 0) return;
            this.validation.push(
                new RequiredIfAllUnselectedValidation(
                    this.employees,
                    () => this.smartMoverHidden,
                    this.labelKeys.validationMessage || 'LABEL_REPORTS_SELECT_AT_LEAST_ONE_EMPL'
                )
            );
        }

        removeValidation () {
            this.validation = [];
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: ng.IQService): ng.IPromise<any> {
            this.employees.updateCriteria(newCriteria);
            return this.employees.fetch();
        }

        onSecurityFail() {
            this.allSelected = false;
            super.onSecurityFail();
        }
    }
}
